export const DeleteSessionContext = {
  CheckoutRetail: 'checkout-retail',
  CheckoutWholesale: 'checkout-wholesale',
  SessionList: 'session-list',
} as const;

export type DeleteSessionContext = (typeof DeleteSessionContext)[keyof typeof DeleteSessionContext];
